import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ForbiddenException } from '../../models/exception/ForbiddenException';
import { BadRequestException } from '../../models/exception/BadRequestException';
import { NotFoundException } from '../../models/exception/NotFoundException';
import { ServerErrorException } from '../../models/exception/ServerErrorException';

@Injectable({
  providedIn: 'root'
})
export class ApiErrorHandlerService {

  constructor() { }

  handle(error: HttpErrorResponse) {
    switch (error.status) { // 401 wordt in authInterceptor afgehandeld
      case 400:
        throw new BadRequestException();
      case 403: 
        throw new ForbiddenException();
      case 404:
        throw new NotFoundException();
      case 500:
        throw new ServerErrorException();
      default: 
        throw error;
    }
  }
}
